import React from 'react';
import { Card } from '../../components/ui/card';
import { Webhook } from 'lucide-react';
import MerchantLayout from '../../components/MerchantLayout';

export default function MerchantWebhooksPage() {
  return (
    <MerchantLayout>
      <div className="space-y-6" data-testid="merchant-webhooks-page">
        <div>
          <h1 className="text-3xl font-bold text-[hsl(var(--brand-ink))]" style={{ fontFamily: 'var(--font-heading)' }}>
            Webhooks
          </h1>
          <p className="text-[hsl(var(--muted-foreground))] mt-1">
            Historial de notificaciones enviadas
          </p>
        </div>

        {/* Coming Soon */}
        <Card className="p-12 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[hsl(var(--brand-teal))]/10 mb-4 mx-auto">
            <Webhook className="w-8 h-8 text-[hsl(var(--brand-teal))]" />
          </div>
          <h2 className="text-xl font-semibold text-[hsl(var(--brand-ink))] mb-2">
            Historial de Webhooks
          </h2>
          <p className="text-[hsl(var(--muted-foreground))] max-w-md mx-auto mb-6">
            Aquí podrás ver todos los webhooks enviados a tu callback URL,
            incluyendo el status, payload, y reintentos.
          </p>
          <div className="text-sm text-[hsl(var(--muted-foreground))] text-left max-w-md mx-auto space-y-2">
            <p>• Ver webhooks enviados</p>
            <p>• Status (success, error, retry)</p>
            <p>• Ver payload completo</p>
            <p>• Fecha y hora de envío</p>
            <p>• Respuesta del servidor</p>
          </div>
        </Card>

        {/* Configuration Info */}
        <Card className="p-6">
          <h3 className="font-semibold text-[hsl(var(--brand-ink))] mb-4">Configuración de Webhooks</h3>
          <div className="space-y-3 text-sm text-[hsl(var(--muted-foreground))]">
            <div className="flex gap-2">
              <span className="font-medium text-[hsl(var(--brand-ink))]">URL:</span>
              <span>Configura tu webhook URL en Configuración</span>
            </div>
            <div className="flex gap-2">
              <span className="font-medium text-[hsl(var(--brand-ink))]">Eventos:</span>
              <span>FUNDED_DETECTED, FORWARDED</span>
            </div>
            <div className="flex gap-2">
              <span className="font-medium text-[hsl(var(--brand-ink))]">Formato:</span>
              <span>POST request con JSON payload</span>
            </div>
            <div className="flex gap-2">
              <span className="font-medium text-[hsl(var(--brand-ink))]">Reintentos:</span>
              <span>3 intentos automáticos con timeout de 30s</span>
            </div>
          </div>
        </Card>

        {/* Example Payload */}
        <Card className="p-6">
          <h3 className="font-semibold text-[hsl(var(--brand-ink))] mb-4">Ejemplo de Payload</h3>
          <pre className="bg-[hsl(var(--accent))] p-4 rounded-lg overflow-x-auto text-xs">
{`{
  "id": "abc-123-def-456",
  "merchant_id": "merchant-uuid",
  "amount_fiat": 50.00,
  "amount_crypto": 50.0,
  "crypto_asset": "USDT-TRON",
  "status": "FORWARDED",
  "deposit_address": "TXxxxxx...",
  "forwarding_tx_hash": "0xabc123...",
  "created_at": "2025-12-04T10:30:00Z",
  "updated_at": "2025-12-04T10:35:00Z"
}`}
          </pre>
        </Card>
      </div>
    </MerchantLayout>
  );
}
